/* import __COLOCATED_TEMPLATE__ from './market-select-with-add-new.hbs.js'; */
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { v4 as uuidv4 } from 'uuid';
import { scheduleOnce, next } from '@ember/runloop';
function localeAndCaseAgnosticSort(arr) {
  return arr.sort((a, b) => Intl.Collator().compare(a.label, b.label));
}
let MultiselectWithAddNew = (_class = class MultiselectWithAddNew extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "searchText", _descriptor2, this);
    _initializerDefineProperty(this, "isOptionsLazyRendered", _descriptor3, this);
    _initializerDefineProperty(this, "uuid", _descriptor4, this);
  }
  get options() {
    return localeAndCaseAgnosticSort(this.args.options);
  }
  get selectedOptions() {
    return this.args.selectedOptions?.join(',');
  }
  get shouldRenderAllOptions() {
    if (!this.args.shouldLazyRenderOptions) {
      return true;
    }
    return this.isOptionsLazyRendered;
  }
  handleDidInsert() {
    if (!this.args.shouldLazyRenderOptions) {
      return;
    }
    scheduleOnce('afterRender', this, this.setIsOptionsLazyRendered);
  }
  setIsOptionsLazyRendered() {
    this.isOptionsLazyRendered = true;
  }
  onSearchValueChange(event) {
    this.searchText = event.detail.current;
  }
  onAddNewClick() {
    if (this.searchText) {
      const selectedOptionsLength = this.args.selectedOptions?.length || 0;
      const searchText = this.searchText;
      this.args.onAddNewClick && this.args.onAddNewClick(this.searchText);
      const marketInputSearch = document.querySelector(`[market-select-with-add-new-search="${this.uuid}"]`);
      marketInputSearch?.clearInput();

      // https://github.com/squareup/dashboard/pull/78778#discussion_r1752431061
      next(() => {
        if (selectedOptionsLength > 0) {
          return;
        }
        const newAddedOptionSelector = `[data-test-market-select-with-add-new-options="${searchText}-${this.uuid}"]`;
        const newAddedOption = document.querySelector(newAddedOptionSelector);
        newAddedOption?.click();
      });
    }
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "searchText", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "isOptionsLazyRendered", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "uuid", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return uuidv4();
  }
}), _applyDecoratedDescriptor(_class.prototype, "handleDidInsert", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleDidInsert"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setIsOptionsLazyRendered", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setIsOptionsLazyRendered"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onSearchValueChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onSearchValueChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onAddNewClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onAddNewClick"), _class.prototype)), _class);
export { MultiselectWithAddNew as default };